export default class SubItemMenuModel {
  id = Date.now();
  title = "";
  url = "";
  isNewSubItem = true;
}
